import $ from 'jquery';


function ready(fn) {
  if (document.readyState != 'loading'){
      fn();
  } else {
      document.addEventListener('DOMContentLoaded', fn);
  }
}

ready(
  function () { 
      initNav();
      const bodyEl = document.querySelector('body');
      if (bodyEl.classList.contains('HelpPage')){
        initHelp();
      }
  }
);

// Navigation
function initNav() {
  document.querySelectorAll('.header__nav-icon').forEach(function(element) { 
    element.addEventListener('click',
      function(event) {
          event.target.parentNode.classList.toggle('header--menu-open');
      });
  });

  // close menu when link has been clicked
  document.querySelectorAll('#bic-search-menu a').forEach(function(element) { 
    element.addEventListener('click',
      function() {
        const banner = document.querySelector('header.header');
        banner.classList.remove('header--menu-open');
      });
  });
}

function initHelp() {
  var h4counter = 0;
  $(".HelpPageContainer").children().each(function() {
      if ($(this).prop("tagName") == "H4") {
          //$(this).append("<span class='link down'><span class='icon'></span></span>");
          $(this).nextUntil("H4").not("H3").wrapAll("<div></div>");

          if ($(this).prev().prop("tagName") == "H3") {
              h4counter = 0;
              $(this).prepend("<span class='h4-section-text'>In this section</span>");

          } else {
              h4counter = h4counter + 1;
          }

          if (h4counter % 2 > 0) {
              $(this).addClass("even").addClass("down");
              $(this).next().addClass("even").hide();
          } else {
              $(this).addClass("odd").addClass("down");
              $(this).next().addClass("odd").hide();
          }

          $(this).click(function() {
              $(this).next().slideToggle();
              $(this).toggleClass("down up");
              // ga('send', {
              //     'hitType': 'event',
              //     'eventCategory': 'Help',
              //     'eventAction': 'Expand Heading',
              //     'eventLabel': $(this).text()
              // });
          });
      }
  });
}

// function toolbar_relocate() {
//   var window_top = $(window).scrollTop();
//   if (typeof $('#sticky-toolbar').offset() != "undefined") {
//       var div_top = $('#sticky-toolbar').offset().top;
//       if (window_top > div_top + 50) {
//           $('.toolbar').addClass('stick');
//           $('.toolbarInner').css("max-width","940px");
//       } else {
//           $('.toolbar').removeClass('stick');
//       }
//   }
// }

// $(window).on('popstate', function() {
//   if ($("#overlay").is(":visible")) {
//       $("#overlay").hide();
//   }
// });

// $(window).on('scroll', function() {
//   if ($(".HomePage") != null) {
//       if ($(window).width() > 767 && $('#sticky-toolbar') != null) { 
//           toolbar_relocate();
//       }
//   }
// });